import React from 'react';
import { Card } from "react-bootstrap";
import face_gergo_orban from "../../assets/img/face_gergo_orban.jpg";
import ShowMoreText from "react-show-more-text";
import projOrbanG_spike from "../../assets/img/projOrbanG_spike.png";

const Gergo_Orban_spike = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={projOrbanG_spike} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_gergo_orban}
              /* this will be the text on the banner */
              alt="Representation learning using deep generative models"
            />{" "}
            <p className="text7">Gergő Orbán</p>
            <br />
            <p className="text8">
              Group Leader{" "}
            </p>
            <p className="text8">Wigner Research Centre for Physics</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            In recent years, generative models have proven to be immensely effective in learning a flexible mapping 
            from discrete spaces (most prominently: natural text) to the high dimensional and versatile continuous 
            space (most prominently: natural images). The most successful example of this family were diffusion models. 
            The goal of the project is to adapt diffusion models to learn a mapping from a different discrete code, 
            neural spiking responses. Through the development of a  spike-to-image diffusion model, there is an opportunity 
            to learn the theory of deep generative models, and get acquainted with the foundations and tools of a central 
            branch of modern machine learning: unsupervised learning. 


            <br />
            <br />

            The project requires knowledge about probability theory, the principles of unsupervised learning, as 
            well as experience with modern scientific programming tools: python + pytorch / tensorflow.



            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Gergo_Orban_spike;